import React from "react";

export const FarmCtx = React.createContext();
export const TimePeriodCtx = React.createContext();
export const PensCtx = React.createContext();
export const RecipesCtx = React.createContext();
export const ConfirmCtx = React.createContext();
export const GroupsCtx = React.createContext();
export const ModulesCtx = React.createContext();
